import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/article",
    name: "Article",
    component: () => import("../views/Article.vue")
  },
  {
    path: "/morecolumn",
    name: "MoreColumn",
    component: () => import("../views/MoreColumn.vue")
  },
  {
    path: "/category",
    name: "Category",
    component: () => import("../views/Category.vue")
  },
  {
    path: "/wap/category",
    name: "Category",
    component: () => import("../views/Category.vue")
  },
  {
    path: "/wap/morecolumn",
    name: "MoreColumn",
    component: () => import("../views/Wap/MoreColumn.vue")
  },
  {
    path: "/wap/article",
    name: "Article",
    component: () => import("../views/Article.vue")
  },
  {
    path: "/wap/origin",
    name: "Origin",
    component: () => import("../views/Wap/Origin.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
